import { IDropdownOption } from '@fluentui/react';
import { BasicList, basicListStylesInput, Item, itemStylesDropdown, KeyboardKey, TextField } from '@h2oai/ui-kit';
import { useState } from 'react';

// TODO: Move to ui-kit
interface ITextListEditorProps {
  items?: string[];
  placeholder?: string;
  onChange: (items: string[]) => void;
}

export const TextListEditor = ({ items = [], placeholder = 'Input with Enter', onChange }: ITextListEditorProps) => {
  const [text, setText] = useState('');
  const [texts, setTexts] = useState(items);
  return (
    <BasicList
      styles={basicListStylesInput}
      idField="key"
      labelField="text"
      data={[{ key: '__input__', text: 'input' }, ...texts?.map((d) => ({ key: d, text: d }))]}
      data-test="text-list-editor"
      horizontal
      itemRenderer={(d: IDropdownOption) =>
        d.key === '__input__' ? (
          <TextField
            styles={{
              root: { height: '27px', marginRight: '4px', width: '170px' },
              fieldGroup: { height: '27px' },
              wrapper: { height: '27px' },
            }}
            name="text"
            placeholder={placeholder}
            value={text}
            onChange={(_e, text = '') => setText(text)}
            onKeyDown={(e) => {
              if (e.key === KeyboardKey.Enter) {
                if (text) {
                  if (!texts.includes(text)) {
                    texts.push(text);
                    setText('');
                    const items = [...texts];
                    setTexts(items);
                    onChange(items);
                  }
                }
                e.preventDefault();
                e.stopPropagation();
              }
            }}
          />
        ) : (
          <Item
            styles={itemStylesDropdown}
            hasClose
            data={d}
            idField="key"
            labelField="text"
            onClose={(d) => {
              const items = [...texts.filter((text) => text !== d.key)];
              setTexts(items);
              onChange(items);
            }}
          />
        )
      }
    />
  );
};
